import { Column } from '~components/table-view';
import dayjs, { datePickerDisplayFormat } from '~libs/dayjs';

import DexReadinessActionCell from '~dex/components/DexReadinessActionCell';

const MISSING_FIELD_LABELS: Record<string, string> = {
  // TAV-3133 follow-up (Beth Kairys review feedback): "session record" read as unclear /
  // ambiguous with the appointment's other (non-DEX) details also shown on this page.
  session_record: 'No DEX data',
  session_location: 'Session location',
  meals_provided: 'Meals provided',
  no_dex_code_mapping: 'No DEX code mapping',
  excluded_client: 'Client excluded from DEX export',
  // TAV-2962: client-level check (not appointment-level like the others above) — flags a client
  // missing the My Aged Care (AC/MAC) number DoHDA now requires for DEX reporting.
  mac_id: 'My Aged Care ID',
};

export const readinessColumns: Column[] = [
  {
    id: 'date',
    header: 'Date',
    type: 'text',
    style: { width: '110px' },
    deriveValue: (row) => (row.date ? dayjs(row.date).format(datePickerDisplayFormat) : ''),
  },
  {
    id: 'reference_number',
    header: 'Reference',
    type: 'text',
    style: { width: '110px' },
  },
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'service_type_name',
    header: 'Service Type',
    type: 'text',
  },
  {
    id: 'package_name',
    header: 'Package',
    caption: "Client's support package name (not the DEX case ID)",
    type: 'text',
    deriveValue: (row) => row.package_name ?? '',
  },
  {
    id: 'dex_outlet_activity',
    header: 'Outlet Activity',
    type: 'text',
    deriveValue: (row) => row.dex_outlet_activity ?? '',
  },
  {
    id: 'care_worker_name',
    header: 'Care Worker',
    type: 'text',
  },
  {
    id: 'missing_fields',
    header: 'Missing Fields',
    type: 'text',
    deriveValue: (row) => {
      const fields: string[] = row.missing_fields ?? [];
      return fields.map((field) => MISSING_FIELD_LABELS[field] ?? field).join(', ');
    },
  },
  {
    id: 'action',
    header: 'Actions',
    type: 'custom',
    component: DexReadinessActionCell,
    // TAV-3133: up to 3 icons on an eligible row (open occurrence, open originating repeat
    // appointment, copy DEX data) - widened from 50px to fit all three without wrapping.
    style: { width: '110px', textAlign: 'center' },
  },
];
